export default __webpack_public_path__ + "images/filtered.svg?00cabe94fb29f33814d87e770c1c3cea";